module.exports = __webpack_public_path__ + "static/logo_rado-d730829474ab536fa3090904fd8d85f2.svg";